import { createContext } from "react";

import type { HallowABFlag } from "../types/enums/HallowABFlag.enum";
import type { MixpanelABFlagValidProps } from "../types/enums/MixpanelABFlagValidProps.enum";

export type MixpanelCustomProperties = {
  [key in (typeof MixpanelABFlagValidProps)[keyof typeof MixpanelABFlagValidProps]]?:
    | "true"
    | "false";
};
export type MixpanelUserContext = Record<string, any> & {
  custom_properties?: MixpanelCustomProperties;
};

export type FlagVariant = "control" | "treatment" | "excluded" | null;

export type MixpanelContext = {
  flags: {
    [key in HallowABFlag]?: {
      isTargeted: boolean;
      variant: FlagVariant;
    };
  };
  isLoading: boolean;
};

export const mixpanelContext = createContext<MixpanelContext>({
  flags: {},
  isLoading: true,
});
